import steps from "state/steps";

const nextSteps = steps.reduce((result, step, index) => {
  result[step] = steps[index + 1] || "complete";
  return result;
}, {});

const getNextStep = currentStep => nextSteps[currentStep];

export default getNextStep;



// WEBPACK FOOTER //
// ./src/state/getNextStep.js